import { create } from 'zustand'

interface DepartmentInfo {
  id: string
  name: string
}

interface DepartmentSelectionState {
  selectedDepartments: Map<string, DepartmentInfo>

  toggleDepartment: (dept: DepartmentInfo) => void
  selectAll: (depts: DepartmentInfo[]) => void
  clearSelection: () => void
  isSelected: (id: string) => boolean
}

export const useDepartmentSelectionStore = create<DepartmentSelectionState>()(
  (set, get) => ({
    selectedDepartments: new Map(),

    toggleDepartment: dept =>
      set(state => {
        const next = new Map(state.selectedDepartments)
        if (next.has(dept.id)) {
          next.delete(dept.id)
        } else {
          next.set(dept.id, dept)
        }
        return { selectedDepartments: next }
      }),

    selectAll: depts =>
      set(() => {
        const next = new Map<string, DepartmentInfo>()
        depts.forEach(d => next.set(d.id, d))
        return { selectedDepartments: next }
      }),

    clearSelection: () => set({ selectedDepartments: new Map() }),

    isSelected: id => get().selectedDepartments.has(id),
  })
)
